import type { AppliedLesson } from '@/models/appliedlesson';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import type { Lesson } from '@/models/lesson';
import type { XLesson } from '@/models/xlesson';
import type { PMLesson } from '@/models/pmlesson';

export const sortAppliedLessons = <T extends AppliedLesson | XAppliedLesson | PMAppliedLesson>(a: T, b: T) => {
    return a && a.lesson && b && b.lesson ? a.lesson.order - b.lesson.order : 0;
};

export const sortLessons = <T extends Lesson | XLesson | PMLesson>(a: T, b: T) => {
    if ((a as any).lesson && (b as any).lesson) {
        return (a as any).lesson.order - (b as any).lesson.order;
    }
    console.log(a, b);
    return a && b ? a.order - b.order : 0;
};
